import { Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import type { ExplodedErrorRow } from "../types";

export const errorColumns: ColumnsType<ExplodedErrorRow> = [
  { title: "Счётчик", dataIndex: "meter_id", width: 120 },
  {
    title: "Объект",
    dataIndex: "object_name",
    width: 200,
    render: (_value, row) =>
      row.object_name ? `${row.object_name} (№${row.object_id ?? "?"})` : "—",
  },
  {
    title: "Связь",
    dataIndex: "connection_state",
    width: 70,
    render: (_value, row) =>
      row.connection_state === 1 ? <Tag color="green">есть</Tag> : <Tag color="red">нет</Tag>,
  },
  {
    title: "Код",
    dataIndex: "error_code",
    width: 80,
    render: (value?: string) => {
      if (!value) return <Tag color="default">—</Tag>;
      return (
        <Tag color="purple" style={{ fontFamily: "monospace" }}>
          {value}
        </Tag>
      );
    },
  },
  {
    title: "Расшифровка",
    dataIndex: "error_description",
    width: 280,
    render: (value?: string) => {
      if (!value) return <Tag color="default">—</Tag>;
      return <Tag color="red">{value}</Tag>;
    },
  },
  {
    title: "Ош. связи",
    dataIndex: "comm_errors",
    width: 80,
    render: (value?: number) => (value ? <Tag color="red">{value}</Tag> : "—"),
  },
  {
    title: "Ош. прот.",
    dataIndex: "protocol_errors",
    width: 80,
    render: (value?: number) => (value ? <Tag color="orange">{value}</Tag> : "—"),
  },
  {
    title: "Время",
    dataIndex: "sys_error_at",
    width: 110,
    render: (value?: string) => (value ? dayjs(value).format("DD.MM HH:mm") : "—"),
  },
];
